import React, { useContext } from "react";
import { ButtonRenderProps, ButtonProps, ContentSection, Stack, LabeledText } from "sprint-common-web";

import { SeasonPageContext } from "../context/SeasonPageContext";
import { EditSeasonButton } from "./buttons/EditSeasonButton";

export const SeasonInfo: React.FunctionComponent = () => {
    const { selectedSeason } = useContext(SeasonPageContext);

    const editButtonProps: ButtonRenderProps<ButtonProps> = {
        render: () => EditSeasonButton({ isLabeled: true, seasonId: selectedSeason.id })
    };

    return (
        <ContentSection header="Info" buttons={[editButtonProps]}>
            <Stack horizontal={true} tokens={{ childrenGap: "100" }}>
                <LabeledText value={selectedSeason.name} label="Name" />
                <LabeledText value={selectedSeason.number} label="Season Number" />
            </Stack>
        </ContentSection>
    );
};
